import React, { useState, useRef, useEffect } from 'react';

import { toastActions } from '../../../../components/uielements/toast/toast';
import { IntlMessages } from '../../../../helper/langHelper';
import AdminModal from '../../../../components/uielements/modal/adminModal';

import {
  FormWrapper,
  FormSection,
  FieldGroup,
  Label,
  ErrorText,
  ButtonContainer,
  PrimaryButton,
  UserNameDisplay,
} from './UserPromoteModal.styles';
import { userDemote } from '../../../../services/admin/users';
import SelectComponent from '../../../../components/uielements/selectComponent/select';

const USER_TYPE_OPTIONS = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'COUNCIL', label: 'Council' },
];

const UserDemoteModal = ({ onClose, userName, userId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedUserType, setSelectedUserType] = useState(null);
  const userTypeRef = useRef(null);

  const handleUserTypeChange = (option) => {
    setSelectedUserType(option);

    if (error) {
      setError('');
    }
  };

  const validateForm = () => {
    if (!selectedUserType) {
      setError('Please select a user type.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      await userDemote({
        userType: selectedUserType.value,
        userId,
      });

      toastActions.success(<IntlMessages id="toast.user.demote.success" />);

      setSelectedUserType(null);
      onClose();
    } catch (err) {
      toastActions.error(<IntlMessages id="toast.user.demote.error" />);
      setError(err?.message || 'Failed to demote user. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSelectedUserType(null);
    setError('');
    onClose();
  };

  const footer = (
    <ButtonContainer>
      <PrimaryButton type="submit" disabled={loading || !selectedUserType}>
        {loading ? 'Demoting…' : 'Demote User'}
      </PrimaryButton>
    </ButtonContainer>
  );

  return (
    <AdminModal
      isOpen={true}
      onClose={handleCloseModal}
      title="Demote User"
      footer={footer}
      width="520px"
    >
      <FormWrapper onSubmit={handleSubmit}>
        {error && <ErrorText>{error}</ErrorText>}

        <FormSection>
          {/* User Name Display */}
          {userName && (
            <FieldGroup>
              <Label>User</Label>
              <UserNameDisplay>{userName}</UserNameDisplay>
            </FieldGroup>
          )}

          <FieldGroup>
            <SelectComponent
              options={USER_TYPE_OPTIONS}
              onSelect={(option) => handleUserTypeChange(option)}
              label="User Type"
              placeholder="Select user type..."
            />
          </FieldGroup>
        </FormSection>
      </FormWrapper>
    </AdminModal>
  );
};

export default UserDemoteModal;
